import { useInvalidateReturnRequest } from "@babackapp/private-api-client/client/use-invalidate-return-request";
import { useQueryClient } from "@tanstack/react-query";
import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export default function useStripeIntegrationPaymentRefundMutation(
  shop: ShopDto,
) {
  const queryClient = useQueryClient();
  const invalidateReturnRequest = useInvalidateReturnRequest();

  return useApiMutation(
    "post",
    "/shops/{shopId}/integrations/stripe/payment-intent/{paymentIntentId}/refund",
    {
      onSuccess: async (_data, variables: {
        paymentIntentId: string;
        amount: number;
        returnRequestId: string;
      }) => {
        await queryClient.invalidateQueries({
          queryKey: [
            "get",
            "/shops/{shopId}/integrations/stripe/payment-intent/{paymentIntentId}",
            {
              params: {
                path: {
                  shopId: shop.id,
                  paymentIntentId: variables.paymentIntentId,
                },
              },
            },
          ],
          refetchType: "all",
        });

        invalidateReturnRequest({
          returnRequestId: variables.returnRequestId,
          shopId: shop.id,
        });
      },
      mapVariables: (variables: {
        paymentIntentId: string;
        amount: number;
        returnRequestId: string;
      }) => ({
        params: {
          path: { shopId: shop.id, paymentIntentId: variables.paymentIntentId },
        },
        body: {
          amount: variables.amount,
          returnRequestId: variables.returnRequestId,
        },
      }),
    },
  );
}
